import axiosClient from "../api/axiosClient";

// Link a new device using the short code shown on the device that requested pairing
// (the secondary/checkin device — always the PSA phone app, never this panel).
export const approvePairingByCode = (shortCode, deviceName) =>
  axiosClient.post("/linkeddevices/approve-pairing", {
    ShortCode: shortCode,
    DeviceName: deviceName,
  });

export const getLinkedDevices = () => axiosClient.get("/linkeddevices");

export const assignDevice = ({ linkedDeviceId, eventId, qrType, locationQRCodeId }) =>
  axiosClient.post("/linkeddevices/assign", {
    LinkedDeviceId: linkedDeviceId,
    EventId: eventId,
    QRType: qrType,
    LocationQRCodeId: locationQRCodeId ?? null,
  });

export const disconnectDevice = (linkedDeviceId) =>
  axiosClient.post("/linkeddevices/disconnect", { LinkedDeviceId: linkedDeviceId });

export const unassignDevice = (linkedDeviceId) =>
  axiosClient.post("/linkeddevices/unassign", { LinkedDeviceId: linkedDeviceId });

export const blockDeviceAssignment = (linkedDeviceId, reason) =>
  axiosClient.post("/linkeddevices/block-assignment", { LinkedDeviceId: linkedDeviceId, Reason: reason });

export const grantDeviceLocationException = (linkedDeviceId, durationMinutes, reason, warningConfirmed) =>
  axiosClient.post("/linkeddevices/location-exception", { LinkedDeviceId: linkedDeviceId, DurationMinutes: durationMinutes, Reason: reason, WarningConfirmed: warningConfirmed });
